import { FC, MouseEvent } from 'react'

import { useModuleContext } from '../contexts/ModuleContext'
import { ElectricalCode, ResourceImage } from '../Types'

import { simMod } from '../Module.config'
import Menu, { MenuItem } from './Menu'

type Props = {
    visible: boolean
    hideMenu: () => void
    showDiagram: (diagram: ResourceImage) => void
}

const FolderMenu: FC<Props> = ({ visible, hideMenu, showDiagram }: Props) => {
    const { user: { electricalCode } } = useModuleContext()

    if (simMod.diagrams.length === 0) throw new Error('This module has no diagrams configured.')

    const handleMenuItemClick = (e: MouseEvent<HTMLElement>, diagram: ResourceImage) => {
        e.preventDefault()
        hideMenu()
        showDiagram(diagram)
    }

    const menuItems = simMod.diagrams.map((diagram: ResourceImage, idx: number) => (
        <MenuItem
            key={'d' + idx}
            text={
                diagram.nameIEC && electricalCode === ElectricalCode.NEC
                    ? diagram.nameIEC
                    : diagram.name
            }
            onClick={(e) => handleMenuItemClick(e, diagram)}
        />
    ))

    return (
        <Menu
            title={'References'}
            visible={visible}
            onOutsideClick={hideMenu}
        >
            {menuItems}
        </Menu>
    )
}
export default FolderMenu

